import styled, { css } from 'styled-components';
import Split from 'react-split';

import { colors } from 'global/colors';

export const ResizableRowsContainer = styled(Split)`
  height: 100%;

  & .gutter.gutter-vertical {
    cursor: row-resize;
    ${({ splitdarkmode }) =>
      css`
        background-color: ${splitdarkmode ? colors.black : colors.lightGray};
      `};
    :hover {
      background-color: ${colors.fsCyan};
    }
  }
`;

export const RowContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
